/* eslint-disable */
require('./about')
require('./adress')
require('./arrow-down-3')
require('./arrow-down-2')
require('./arrow-down')
require('./arrow-left-otg-black')
require('./arrow-left-otg-green')
require('./arrow-left-otg')
require('./arrow-left-dark-no')
require('./arrow-left-transparent')
require('./arrow-left-sk')
require('./arrow-left')
require('./arrow-right-2')
require('./arrow-right-3')
require('./arrow-right-4')
require('./arrow-right-dark')
require('./arrow-right')
require('./arrow-up-2')
require('./arrow-up')
require('./back-arrow-otg')
require('./back-icon')
require('./brands')
require('./care-green')
require('./care')
require('./category-logo')
require('./checkbox')
require('./clock')
require('./close-adopt')
require('./close-black-2')
require('./close-black-regular')
require('./close-black')
require('./close-pink')
require('./close-circle')
require('./close-otg-black')
require('./close-white')
require('./close-white-2')
require('./close')
require('./compass-active')
require('./compass-adopt')
require('./compass-off')
require('./compass-otg')
require('./compass-otg-2')
require('./compass-otg-3')
require('./compass-shape')
require('./compass-shape-red')
require('./compass')
require('./connection')
require('./delete')
require('./easy-path-pink')
require('./easy-way-red')
require('./easy-way-3-black')
require('./easy-way-3-white')
require('./easy-way-4-black')
require('./easy-way-4-white')
require('./easy-way-6-red')
require('./easy-way-6-white')
require('./edit')
require('./eye-cross')
require('./eye')
require('./fail-mark-otg')
require('./fail')
require('./fast-way-3-black')
require('./fast-way-3-white')
require('./fast-way-6-white')
require('./fast-way-6-red')
require('./fast-way-5-white')
require('./fast-way-4-black')
require('./fast-way-4-white')
require('./finish-red')
require('./finish')
require('./floor')
require('./full-screen')
require('./gmap-button-icon')
require('./google_maps')
require('./granby-easy-guide-icon-white')
require('./granby-easy-guide-icon')
require('./granby-fast-guide-icon-black')
require('./granby-fast-guide-icon')
require('./guide-path-red')
require('./guide-path-white')
require('./guide-path')
require('./hamburger')
require('./hand')
require('./handset-green')
require('./handset')
require('./hash')
require('./home')
require('./icon-clock')
require('./logo_mobile')
require('./m-serch-setting')
require('./map-zoom-minus')
require('./map-zoom-plus')
require('./marker')
require('./minus')
require('./mobile_items_care')
require('./mobile_items_services')
require('./mvg-powered')
require('./path-dark')
require('./path-white')
require('./path')
require('./path-2')
require('./phone-path')
require('./phone')
require('./phone-2')
require('./plan')
require('./plus_mobile')
require('./plus-dark')
require('./plus')
require('./poster-category')
require('./question-mark')
require('./redirect')
require('./reset-guide')
require('./scroll-up')
require('./search_mobile')
require('./search-mobilia')
require('./search-otg')
require('./search-red')
require('./search-without-box')
require('./search')
require('./send')
require('./spiner')
require('./service-white')
require('./service')
require('./services')
require('./shop-logo')
require('./space')
require('./start-step-active-bg')
require('./start-step-bg')
require('./start')
require('./store-path')
require('./success-mark-otg')
require('./success')
require('./switcher-circle-icon')
require('./warning')
require('./web')
require('./write-input')
require('./write-us')
